export default {
    carReservations: [],
    carReservationsTypes: [],
    carReservationsStatuses: []
}